// Klinikler (admin) listesinin saf yardımcıları — arama ve sıralama.
// Bileşenden ayrı tutulur ki test edilebilsin.

import { SORTERS } from "../../components/organisms/ClinicRecordList";

const lower = (v) => String(v ?? "").toLocaleLowerCase("tr");

/** Liste sırası/sütunu için oluşturulma tarihi (şemada `createdInfo`). */
export const createdOf = (c) => c?.createdInfo || c?.createdAt;

/** "İlçe · İl" — adres alanı boşsa null. */
export const locationOf = (c) => [c?.address?.district, c?.address?.city].filter(Boolean).join(" · ") || null;

/**
 * Tek arama kutusu: ad, e-posta, telefon, klinik kodu, puser no ("#1042" de olur),
 * il/ilçe/adres. `text` küçük harf ve kırpılmış gelir (useClientList).
 */
export function matchesClinic(c, text) {
  const puser = text.replace(/^#+/, "");
  if (puser && /^\d+$/.test(puser) && String(c?.puserNo ?? "").includes(puser)) return true;
  const digits = text.replace(/\D/g, "");
  if (digits.length >= 3 && String(c?.phone || "").replace(/\D/g, "").includes(digits)) return true;
  return [
    c?.name,
    c?.email,
    c?.clinicCode,
    c?.address?.city,
    c?.address?.district,
    c?.address?.fullAddress,
  ].some((v) => lower(v).includes(text));
}

const collator = new Intl.Collator("tr", { sensitivity: "base" });

export const CLINIC_SORTERS = {
  name: (a, b) => collator.compare(String(a?.name || ""), String(b?.name || "")),
  location: (a, b) => collator.compare(locationOf(a) || "", locationOf(b) || ""),
  date: SORTERS.date(createdOf),
};

export const CLINIC_DEFAULT_DIR = { name: "asc", location: "asc", date: "desc" };
